<div class="installment-header">
  {{ "installment.onlineInstallment" | translate }}
</div>
<div class="installment-container">
  <div class="installment-item" *ngFor="let installment of installmentPlans">
    <img  loading="lazy"  [src]="installment.image"    [alt]="installment.alt" />
    <div class="installment-data" [ngClass]="lang == 'ar' ? 'ar-view' : ''">
      <p>
        {{
          lang == "en" ? installment.installment_en : installment.installment_ar
        }}
      </p>
      <p>
        {{ lang == "en" ? installment.payment_en : installment.payment_ar }}
      </p>
    </div>
  </div>
</div>

<div class="valid-till">
  {{ "installment.valid" | translate }}
</div>
